// Libraries
import React, {useState, useRef, useEffect} from 'react';

// Components
import Icon from '../icon';

// Styled
import {DrawerStyled} from './styled'; 

interface IDrawer {
    children?: React.ReactNode,
    style?: React.CSSProperties,
    className?: string,
    placement?: string,
    maxSize?: number,
    minSize?: number,
    onError?: (error: Error, detail: Record<string, unknown>) => void
}

// Distance of drawer and container
const DISTANCE = 60;

const Drawer: React.FC<IDrawer> = (props) => {
    // State
    const [styleDrawer, setStyleDrawer] = useState(props.style || {});

    // Ref
    const refDrawer: any = useRef<HTMLDivElement>(null);

    // Props
    const {children, minSize, maxSize, placement, style, onError} = props;

    useEffect(() => {
        try {
            if (refDrawer) {
                let newStyleDrawer: React.CSSProperties = {...styleDrawer};
    
                switch (placement) {
                    case 'bottom':
                        newStyleDrawer.minHeight = minSize;
                        newStyleDrawer.maxHeight = maxSize;
                        break;
                
                    default:
                        break;
                }
    
                newStyleDrawer = {
                    ...newStyleDrawer
                };
    
                setStyleDrawer(newStyleDrawer);
    
            }
        } catch (error) {
            if (typeof onError === 'function') {
                onError(error, {
                    action: 'useEffectRefDrawer',
                    args: {refDrawer, minSize, maxSize}
                });
            }
        }
    }, [refDrawer, minSize, maxSize]);

    const resize = (e): void => {
        try {
            const {clientY} = e;

            let parentHeight =  0;
            
            if (refDrawer.current !== null) {
                parentHeight = refDrawer.current.parentElement.clientHeight;
            }

            setStyleDrawer({
                ...styleDrawer,
                height: parentHeight - clientY + DISTANCE
            });
        } catch (error) {
            if (typeof onError === 'function') {
                onError(error, {
                    action: 'resize',
                    args: {styleDrawer}
                });
            }
        }
    };

    const stopResize = (): void => {
        try {
            window.removeEventListener('mouseup', stopResize);
            window.removeEventListener('mousemove', resize);

            const elBody = document.querySelector('body');

            if (elBody) {elBody.style.cursor = 'default'}

        } catch (error) {
            if (typeof onError === 'function') {
                onError(error, {
                    action: 'stopResize',
                    args: {}
                });
            }
        }

    };

    const onMouseMoveResize = (): void => {
        try {
            window.addEventListener('mouseup', stopResize);
            window.addEventListener('mousemove', resize);

            const elBody = document.querySelector('body');

            if (elBody) {elBody.style.cursor = 'grabbing'}

        } catch (error) {
            if (typeof onError === 'function') {
                onError(error, {
                    action: 'onMouseMoveResize',
                    args: {}
                });
            }
        }
    };

    return (
        <DrawerStyled ref={refDrawer} style={{...style, ...styleDrawer}}>
            <div className='drag-resize'>
                <Icon className='icon-antsomi-ellipsis-h' onMouseDown={onMouseMoveResize} />
            </div>
            {children}
        </DrawerStyled>
    );
};

Drawer.defaultProps = {
    style: {},
    className: '',
    placement: 'bottom',
    children: null,
    minSize: 300,
    maxSize: 1000
};

export default Drawer;